<template>
  <form @submit.prevent="addNetwork">
    <modal-card title="Add Network" class="">
      <b-field label="SSID">
        <b-input
          v-model="form.ssid"
          maxlength="250"
        ></b-input>
      </b-field>

      <b-field label="IPV4">
        <b-input
          v-model="form.ipv4"
          maxlength="250"
        ></b-input>
      </b-field>
      <div slot="foot">
        <button type="button" class="button" @click="$parent.close()">
          Close
        </button>
        <button class="button is-primary">
          Add Network
        </button>
      </div>
    </modal-card>
  </form>
</template>

<script>
export default {
  props: {
    vendor: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      activeTab: 0,
      isImageModalActive: false,
      publication: 1,
      form: new window.Form({
        'ssid': null,
        'ipv4': null
      })
    }
  },
  methods: {
    addNetwork: function () {
      this.form.post(`/admin/api/wifi/vendors/${window.app.$route.params.id}/networks`).then(() => {
        this.whenAdded();
      });
    },
    whenAdded() {
      this.$emit('reload', 'network')
      this.$parent.close()
    }
  }
}
</script>
